"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealSandwichChickenLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealSandwichChickenLinear = function MealSandwichChickenLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.414l2.277 2.277.031.031 11.984 11.984v.001l7 7 .002.001L31.586 32H9V9.414zm4.74 1.912L24.415 22h2.578a1.844 1.844 0 00-.44-.31 3.844 3.844 0 01-2.035-4.143l.169-.892a2.324 2.324 0 00-2.578-2.738l-.8.101a3.417 3.417 0 01-3.746-2.563 1.417 1.417 0 00-1.946-.954l-1.875.825zM29.324 22H31a1 1 0 011 1v6.586l1 1c1.26 1.26.368 3.414-1.414 3.414H9a2 2 0 01-2-2V9.414C7 7.632 9.154 6.74 10.414 8l1.81 1.81 2.587-1.14a3.417 3.417 0 014.691 2.302 1.417 1.417 0 001.554 1.062l.8-.101c2.914-.371 5.341 2.208 4.795 5.094l-.17.892a1.844 1.844 0 00.977 1.987A3.833 3.833 0 0129.323 22zM30 27.586L26.414 24H30v3.586zM12 16a1 1 0 011 1v12a1 1 0 01-2 0V17a1 1 0 011-1zm4 4a1 1 0 011 1v8a1 1 0 01-2 0v-8a1 1 0 011-1zm5 5a1 1 0 10-2 0v4a1 1 0 002 0v-4zm3 2a1 1 0 011 1v1a1 1 0 01-2 0v-1a1 1 0 011-1zm6-14a1 1 0 11-2 0 1 1 0 012 0zm-1 5a1 1 0 100-2 1 1 0 000 2z",
    fill: "#95A0B3"
  }));
};

exports.MealSandwichChickenLinear = MealSandwichChickenLinear;
var _default = MealSandwichChickenLinear;
exports.default = _default;